import { useState, useEffect } from 'react'
import { PersistentStorage } from '@src/utils/createPersistentStorage'

export const usePersistentStorage = <T>(
  storage: PersistentStorage<T>
): T | null => {
  const [data, setData] = useState(storage.get())
  useEffect(() => {
    const unsubscribe = storage.listen((e) => setData(e.newValue))
    return () => unsubscribe()
  }, [])
  return data
}
